// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemsGroupNewItemLayer_container__6Wcfb","newItem":"ItemsGroupNewItemLayer_newItem__1g5vA","newItemInner":"ItemsGroupNewItemLayer_newItemInner__14YG3"};